import { Illus } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { useDependencies } from '../../../../../state'
import { ActionBar } from '../../../../organisms/form'
import { FullPage } from '../../../../templates'

const tKey = TKey('pages.adjustment-error')

interface AdjustmentErrorPageProps {
  verificationClear: boolean
  onComplete: () => void
}

export const AdjustmentErrorPage: FunctionComponent<AdjustmentErrorPageProps> = ({
  verificationClear,
  onComplete,
}) => {
  const { t } = useWriskTranslation()

  const { chatClient } = useDependencies()

  const message = !verificationClear
    ? t(tKey('failedVerificationMessage'))
    : t(tKey('defaultMessage'))

  return (
    <FullPage
      pageId='adjustment-error-page'
      header={t(tKey('header'))}
      subheader={message}
      upperHeader={<Illus alt='Error' illus='bindError' />}
    >
      <ActionBar
        onConfirm={chatClient.show}
        onDismiss={onComplete}
        loading={false}
        tKey={tKey}
      />
    </FullPage>
  )
}
